// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__+ZKzr","imageSection":"Login_imageSection__MJSSm","formSection":"Login_formSection__k29jH"};